import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import students from './students';
import family from './family';
import staff from './staff';
import parentBlank from './parentBlank';
import modalUsers from './modalUsers';
import blanks from './blanks';
import preloader from './preloader';
import campuses from './campuses';
import countries from './countries';
import abilities from './abilities';
import workers from './workers';
import settings from './settings';
import serviceOrders from './service-orders';
import front from './front';
import managementList from './management-list';
import studyCenter from './study-center';
import studyCenterV2 from './study-center-v2';
import studyCenterDay from './studyCenter/day';
import studyCenterLessons from './studyCenter/lessons';
import studyCenterPopup from './studyCenter/popup';
import security from './security';
import Services from '@/Misc/Services';
import ServiceModule from '@/Plugins/ServiceModule';
import hollydays from './hollydays';

Vue.use(Vuex);

const abilityPlugin = store => {
  const ability = store.getters['abilities/getAbilities'];

  ability.update([{ subject: 'all', action: store.state.abilities.abilities }]);

  return store.subscribe(mutation => {
    switch (mutation.type) {
      case 'abilities/SET_ABILITIES':
        ability.update([{ subject: 'all', action: mutation.payload }]);
        break;
    }
  });
};

const store = new Vuex.Store({
  plugins: [abilityPlugin],
  modules: {
    auth,
    modalUsers,
    students,
    family,
    staff,
    parentBlank,
    blanks,
    hollydays,
    preloader,
    campuses,
    countries,
    abilities,
    workers,
    settings,
    serviceOrders,
    front,
    managementList,
    studyCenter,
    studyCenterV2,
    security,
    studyCenterDay,
    studyCenterLessons,
    studyCenterPopup
  }
});

store.$services = Services;
store.$service = {
  create: ServiceModule.create,
  retrieve: ServiceModule.retrieve,
  update: ServiceModule.update,
  delete: ServiceModule.delete
};

export default store;
